import styled from '@emotion/styled';
import { Button, Stack } from '@ui-components/neo.tax';

export const StyledForm = styled.form({
  display: 'flex',
  flexDirection: 'column',
});

export const ProfileContainer = styled(Stack)({
  gap: '2rem',
});

export const ProfileHeader = styled(Stack)({
  gap: '1.5rem',
});

export const LogoutButton = styled(Button)({
  position: 'absolute',
  left: 20,
  bottom: 20,
});
